module.exports = __webpack_public_path__ + "img/Menu-06.60bff9a1.png";